import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Select, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import Swal from "sweetalert2";
import { getBase64Img } from "utils";

export const EditBannerModal: React.FC<any> = ({ ...props }) => {
	const [isActive, setIsActive] = useState<boolean>(false);
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);
	const [option, setOption] = useState<string>("");

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,

		currentImgURL,
		setProductStatus,

		setProductIsHighlight,
		setBanners,
		currentBannerInfo,
	} = props;
	const { Option } = Select;

	const handleRegister = (values: any) => {
		api
			.put(`/banners/${currentBannerInfo?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					setBanners && setBanners(undefined);
					api.get("/banners").then((res) => {
						setBanners && setBanners(res.data.data.banners);
					});
					form.resetFields();
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				title: currentBannerInfo?.title,
				description: currentBannerInfo?.description,
				url: currentBannerInfo?.url,
				position: currentBannerInfo?.position
					? currentBannerInfo?.position
					: "top",
				order: currentBannerInfo?.order ? currentBannerInfo?.order : 1,
			});
			setCurrentImgURL(
				currentBannerInfo?.image ? currentBannerInfo?.image : ""
			);
			setIsActive(currentBannerInfo?.is_active === true ? true : false);
		}
		// eslint-disable-next-line
	}, [isOpen]);

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Editar banner</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar banner"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasEdited
							? {
									...values,
									position: option ? option : "",
									active: isActive,
									image: currentImgURL,
									target: "_blank",
									type: "home",
							  }
							: {
									...values,
									target: "_blank",
									type: "home",
									position: option ? option : "",
									active: isActive,
							  };

						handleRegister(allValues);
						console.log(allValues);
						setCurrentImgURL("");
						setProductStatus(false);
						setProductIsHighlight(false);
						setIsActive(false);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
				setProductStatus(false);
				setProductIsHighlight(false);
				setIsActive(false);
				form.resetFields();
			}}
			className="m-modal-product"
		>
			<Form form={form} name="new-course" autoComplete="off">
				<div className="m-product-modal">
					<div className="m-product-modal__login-info">
						<div className="m-product-modal__login-info__avatar">
							{currentImgURL ? (
								<img src={currentImgURL} alt="" width="100%" height="100%" />
							) : (
								<FileImageOutlined />
							)}
							<label
								htmlFor="avatar"
								className="m-product-modal__login-info__avatar__btn"
							>
								Escolha uma foto
							</label>
							<Input
								id="avatar"
								type="file"
								accept="image/*"
								style={{ display: "none" }}
								onClick={() => {}}
								onChange={(e) => {
									if (e.target.files?.[0]) {
										setImageWasEdited(true);
										getBase64Img(e.target.files?.[0] as Blob, setCurrentImgURL);
									}
								}}
							/>
						</div>
						<div
							className="m-product-modal__login-info__inputs"
							style={{ justifyContent: "space-evenly" }}
						>
							<Form.Item
								name="title"
								rules={[
									{
										required: true,
										message: "Título necessário",
									},
								]}
							>
								<Input placeholder="Título do banner" />
							</Form.Item>
							<Form.Item
								name="description"
								rules={[
									{
										required: true,
										message: "Descrição necessária",
									},
								]}
							>
								<Input placeholder="Descrição do banner" />
							</Form.Item>
							<Form.Item
								name="url"
								rules={[
									{
										required: true,
										message: "URL necessária",
									},
								]}
							>
								<Input placeholder="URL do banner" />
							</Form.Item>
							<Form.Item
								name="order"
								rules={[
									{
										required: true,
										message: "Ordem necessária",
									},
								]}
							>
								<Input placeholder="Ordem do banner" />
							</Form.Item>

							<div
								style={{
									display: "flex",
									width: "91%",
									alignItems: "center",
									justifyContent: "end",
								}}
							>
								<Form.Item
									name="position"
									rules={[
										{
											required: true,
											message: "Visibilidade necessária",
										},
									]}
									style={{ margin: 0, width: "50%" }}
								>
									<Select
										placeholder="Posição"
										className="m-product-modal__select"
										value={option}
										onChange={(e) => setOption(e)}
										style={{ width: "90%" }}
									>
										<Option value="top">Topo</Option>
									</Select>
								</Form.Item>

								<div
									className="m-product-modal__status"
									style={{ marginLeft: "10px" }}
								>
									<p>Ativo</p>
									<Switch checked={isActive} onClick={(e) => setIsActive(e)} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
